import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { lSetAspectRatio } from '@castiron/style-mixins';
import { theme } from '../../constants';

function UIFrame({ children }) {
  return (
    <div css={styles.wrapper}>
      <div css={styles.inner}>{children}</div>
    </div>
  );
}

const styles = {
  wrapper: css`
    position: relative;
    box-shadow: 0px 2px 6px rgb(0 0 0 / 25%);
    ${lSetAspectRatio(theme.uiFrameWidth, theme.uiFrameHeight)};
  `,
  inner: css`
    position: absolute;
    inset: 0;
    inline-size: 100%;
    block-size: 100%;
    overflow: hidden;
  `,
};

UIFrame.propTypes = {
  children: PropTypes.node,
};

export default UIFrame;
